import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { ChannelListDatatableComponent } from './components/channel-list-datatable/channel-list-datatable.component';
import { ChannelDetailsComponent } from './components/channel-details/channel-details.component';

const DECLARATIONS = [ChannelListDatatableComponent, ChannelDetailsComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class ChannelModule {}
